'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers';
export default function configureStore(initialState, middleware = []) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
}